import axios from "axios";

export const GET_MW_TRANSACTION_BY_INVOICE_NUMBER = "GET_MW_TRANSACTION_BY_INVOICE_NUMBER";
export const getMWTransactionByInvoiceNumber = (invoiceNumber) => {
  const request = axios.get(`/moneyworks/transactions/by_invoice_number/${invoiceNumber}.json`);
  return {
    type: GET_MW_TRANSACTION_BY_INVOICE_NUMBER,
    payload: request,
  };
};
